import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "../../styles/insuranceInfoPopup.css";
import detaillogo from "../../Assets/imgs/detail-modal-logo.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import tooltipimage from "../../Assets/imgs/tooltip-img.webp";
import emptycontainer from "../../Assets/imgs/emptyContainer.webp";
import { tagManagerEvents } from "../../utils/GoogleTagManager";
import EventsName from "../../constants/EventsName";
import { Link } from "react-router-dom";

interface InsuranceDetailProps {
  policyDetails: any;
  isPolicyDetailsModalVisible: boolean;
  onHandleClosePolicyDetailsModal: () => void;
  onHandleSelectCover: (coverId: number) => void;
  handleRadioChange: (
    coverId: number,
    coverDetails: any,
    policyDetails: any
  ) => void;
  handleSelectCover: () => void;
  handleUpdateConsent: () => void;
  selectedCoverId: string;
  isConsentChecked: boolean;
  errorMsg: string;
  isPrepaid: boolean;
  policyPlans: any[];
  isLoading: boolean;
}

const createMarkup = (data: string) => {
  return { __html: data };
};

const InsuranceDetail = (props: InsuranceDetailProps) => {
  const [activeTab, setActiveTab] = useState<string>("");

  // Get unique plan types
  const tabOrder = ["DAILY", "MONTHLY", "ANNUAL"];

  // Get unique plan types from API
  const planTypes = Array.from(new Set(props.policyPlans.map((p) => p.type)));

  // Sorted plan types according to fixed order
  const sortedPlanTypes = [
    ...tabOrder.filter((t) => planTypes.includes(t)), // fixed order first
    ...planTypes.filter((t) => !tabOrder.includes(t)), // remaining at end
  ];

  useEffect(() => {
    if (sortedPlanTypes.length > 0 && !activeTab) {
      setActiveTab(sortedPlanTypes[0]); // Default tab
    }
  }, [sortedPlanTypes]);
  const getBackImage = (index: number) => {
    const images = [
      require("../../Assets/imgs/card-bg-1.webp"),
      require("../../Assets/imgs/card-bg-2.webp"),
      require("../../Assets/imgs/card-bg-3.webp"),
      require("../../Assets/imgs/card-bg-4.webp"),
      require("../../Assets/imgs/card-bg-5.webp"),
    ];
    return `url(${images[index % images.length]})`;
  };

  return (
    <>
      <Modal
        show={props.isPolicyDetailsModalVisible}
        size="xl"
        className="detail-modal"
        onHide={props.onHandleClosePolicyDetailsModal}
      >
        <Modal.Header closeButton>
          <div className="detail-logo">{props.policyDetails.policy?.title}</div>
        </Modal.Header>
        <Modal.Body>
          <div className="detail-content">
            <div className="row">
              {/* Left Section */}
              <div className="col-lg-6 col-md-6 col-12">
                <div className="detail-left">
                  <div
                    dangerouslySetInnerHTML={createMarkup(
                      props.policyDetails.policy?.description
                    )}
                  />
                  <div className="ins_heading">Benefits</div>
                  <div
                    dangerouslySetInnerHTML={createMarkup(
                      props.policyDetails.policy?.benefits
                    )}
                  />
                </div>
              </div>

              {/* Right Section */}
              <div className="col-lg-6 col-md-6 col-12">
                <div className="detail-right">
                  <div className="detail-title">Select Cover</div>

                  {/* Tabs */}
                  <ul className="nav nav-tabs mb-3">
                    {sortedPlanTypes.map((type) => (
                      <li className="nav-item" key={type}>
                        <button
                          className={`nav-link ${
                            activeTab === type ? "" : "active"
                          }`}
                          onClick={() => setActiveTab(type)}
                        >
                          {type.charAt(0).toUpperCase() +
                            type.slice(1).toLowerCase()}
                        </button>
                      </li>
                    ))}
                  </ul>

                  {/* Plans under active tab */}
                  <div className="row">
                    {props.policyPlans.filter((p) => p.type === activeTab)
                      .length > 0 ? (
                      props.policyPlans
                        .filter((p) => p.type === activeTab)
                        .map((item: any, index: number) => (
                          <div
                            className="col-lg-6 col-md-12 col-12"
                            key={item.id}
                          >
                            <div
                              className={`detail-card a ${
                                props.selectedCoverId === String(item.id)
                                  ? "selected"
                                  : ""
                              }`}
                              style={{
                                backgroundImage: getBackImage(index),
                              }}
                            >
                              <div className="detail-input">
                                <div className="radio">
                                  <input
                                    type="radio"
                                    id={`cover-${item.id}`}
                                    name="cover"
                                    value={item.id}
                                    onChange={() => {
                                      props.handleRadioChange(
                                        item.id,
                                        item,
                                        props.policyDetails.policy
                                      );
                                      tagManagerEvents(
                                        EventsName.SubSubProductClick,
                                        ""
                                      );
                                    }}
                                    checked={props.selectedCoverId === item.id}
                                  />
                                  <label htmlFor={`cover-${item.id}`}>
                                    {item.title}
                                  </label>
                                </div>
                                <div className="plan_tooltip">
                                  <img src={tooltipimage} alt="" />
                                  <div className="plan_tooltiptext">
                                    <div className="tooltip-title">
                                      Benefits
                                    </div>
                                    <div className="plan_tooltiptext-desc">
                                      {item.description}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="detail-price">
                                <div className="charge">
                                  {item.type === "DAILY"
                                    ? "Daily"
                                    : item.type === "WEEKLY"
                                    ? "Weekly"
                                    : item.type === "ANNUAL"
                                    ? "Annual"
                                    : "Monthly"}{" "}
                                  Charges
                                </div>

                                <div className="d-price">
                                  <span>{item.charging}</span> Rs.
                                </div>
                              </div>
                              <hr />
                              <div className="detail-price">
                                <div className="charge">Cover Benefit</div>
                                <div className="d-price">
                                  upto <span>{item.cover_benefit}</span> Rs.
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                    ) : (
                      <div className="detail-icon">
                        <img src={emptycontainer} alt="" />
                        <p>Coming Soon</p>
                      </div>
                    )}
                  </div>

                  {/* Consent + Button */}
                  {props.policyPlans.length > 0 && (
                    <div className="selection-section mt-3">
                      <div className="check-box">
                        <input
                          type="checkbox"
                          checked={props.isConsentChecked}
                          onChange={() => {
                            props.handleUpdateConsent();
                            tagManagerEvents(
                              EventsName.TermsAndConditionsClick,
                              ""
                            );
                          }}
                        />
                        <label>
                          I consent buying the product and agree to the{" "}
                          <Link to="/terms" target="_blank">
                            Terms & Conditions
                          </Link>
                        </label>
                      </div>
                      <div className="d-btn">
                        <button
                          onClick={() => {
                            props.handleSelectCover();
                            tagManagerEvents(EventsName.NextToAddDetails, "");
                          }}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                  {props.errorMsg && (
                    <p className="error-msg">{props.errorMsg}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InsuranceDetail;
